import { render } from "./walletMenuEvmIndex.vue?vue&type=template&id=d27904e8"
import script from "./walletMenuEvmIndex.vue?vue&type=script&lang=js"
export * from "./walletMenuEvmIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__